import { ISelectOption } from '@cian/ui-kit/prev/select';

import { REALTOR_RATING_DEFAULT_PERIOD_VALUE, REALTOR_RATING_MIN_PERIOD } from '../../../constants';

/**
 * Формирует опции селектора для филда Период
 */
export const getRealtorRatingPeriodFieldOptions = () => {
  const periods: ISelectOption[] = [{ value: REALTOR_RATING_DEFAULT_PERIOD_VALUE, label: 'За всё время' }];

  for (let currentYear = new Date().getFullYear(); currentYear >= REALTOR_RATING_MIN_PERIOD; currentYear--) {
    periods.push({ value: currentYear.toString(), label: currentYear.toString() });
  }

  return periods;
};
